import Vuex from "vuex";
import Vue from "vue";
// import api from "../../axios/api";
import {
  searchTravelList,
  hotTravelList,
  recommendTravelList,
  recommendTravelNoteList
} from "@/axios/service/travel.js";
Vue.use(Vuex);
const HomeDataStore = {
  namespaced: true,
  state: {
    noResultFlag: false,
    isLogin: false,
    newTravels: [], //10篇游记
    checkform: {},
    recommendTravels: [],
    total: "",
    searchValue: "" //首页搜索字
  },
  mutations: {
    noResultFlagMutations(state, value) {
			state.noResultFlag = value;
		},
    isLoginMutations(state, value) {
      state.isLogin = value;
    },
    newTravelsMutations(state, value) {
      state.newTravels = value;
    },
    formMutations(state, value) {
      state.checkform = value;
    },
    searchValueMutations(state, value) {
      state.searchValue = value;
    },
    setRecommendTravels(state, value) {
      state.recommendTravels = value;
    },
    totalMutations(state, value) {
      state.total = value;
    }
  },
  actions: {
    getnewTravels(context, params) {
      let pageFlag = params.pageFlag;
      searchTravelList(params).then(json => {
        if (json.respCode === 100 && json.data !== undefined) {
          context.commit("newTravelsMutations", json.data);
          context.commit("totalMutations", json.total);
        } else {
          if (pageFlag === "searchTravel") {
						context.commit("noResultFlagMutations", true); 
					}
          // Global.messageErr('获取列表失败');
        }
      });
    },
    recommendTravelNoteList({ commit }, params) {
      recommendTravelNoteList(params).then(json => {
        if (json.respCode === 100 && json.data !== undefined) {
          commit("setRecommendTravels", json.data);
        } else {
          // Global.messageErr('获取列表失败');
        }
      });
    },
    recommendTravelList({ commit }, params) {
      recommendTravelList(params).then(json => {
        if (json.respCode === 100 && json.data !== undefined) {
          commit("setRecommendTravels", json.data);
        } else {
          // Global.messageErr('获取列表失败');
        }
      });
    },
    getHotTravels({ commit }, params) {
      hotTravelList(params).then(json => {
        if (json.respCode === 100 && json.data !== undefined) {
          commit("setRecommendTravels", json.data);
        } else {
          // Global.messageErr('获取列表失败');
        }
      });
    }
  }
};

export default HomeDataStore;
